if (!customElements.get("m-icon-box")) {
  class MIconbox extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = parseInt(this.dataset.items, 10) || 1;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.showPreview = this.dataset.showPreview === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    getSlidesPerView(base, totalSlides, previewAmount = 0) {
      const safeBase = Math.max(1, Number(base) || 1);

      if (!this.showPreview) {
        return Math.min(safeBase, totalSlides);
      }

      if (totalSlides > safeBase) {
        return safeBase + previewAmount;
      }

      return Math.min(safeBase, totalSlides);
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton =
        controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton =
        controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper").childElementCount;
      let __this = this;

      const tabletBase = Math.max(1, this.items - 1);
      const desktopBase = Math.max(1, this.items);

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: this.getSlidesPerView(1, slideItemsLength, 0.12),
        navigation: this.showNavigation,
        loop: slideItemsLength > 1,
        pagination: this.showPagination
          ? {
              el: this.querySelector(".swiper-pagination"),
              clickable: true,
            }
          : false,
        breakpoints: {
          480: {
            slidesPerView: this.getSlidesPerView(2, slideItemsLength, 0.12),
          },
          768: {
            slidesPerView: this.getSlidesPerView(tabletBase, slideItemsLength, 0.14),
          },
          1280: {
            slidesPerView: this.getSlidesPerView(desktopBase, slideItemsLength, 0.16),
          },
        },
        on: {
          init: function () {
            this.slideToLoop(__this.lastActive || 0);

            setTimeout(() => {
              const firstItem =
                __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");

              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                if (prevButton) prevButton.classList.remove("m:hidden");
                if (nextButton) nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const slidesPerView = Number(breakpointParams.slidesPerView) || 1;

              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;

      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-icon-box", MIconbox);
}